
import React, { useState } from 'react';

export const QuickInfoSection: React.FC = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      question: 'O que é PPF e por que aplicar?',
      answer: 'Paint Protection Film é uma película transparente que protege contra riscos, pedradas e impactos. Preserva a pintura original e mantém o valor do veículo.',
      category: 'Proteção'
    },
    {
      question: 'Qual a diferença entre vitrificação e enceramento?',
      answer: 'A vitrificação cria uma camada cerâmica permanente que dura 2-3 anos, enquanto cera comum dura apenas algumas semanas. Oferece proteção e brilho superiores.',
      category: 'Proteção'
    },
    {
      question: 'Película solar realmente funciona?',
      answer: 'Sim! Reduz até 70% do calor interno, bloqueia 99% dos raios UV nocivos e oferece privacidade sem comprometer a visibilidade.',
      category: 'Conforto'
    },
    {
      question: 'Quanto tempo duram os serviços?',
      answer: 'PPF: 5-10 anos | Vitrificação: 2-3 anos | Película Solar: 5-8 anos | Polimento: 6-12 meses. Todos com garantia Aura.',
      category: 'Durabilidade'
    },
    {
      question: 'Posso lavar o carro normalmente após os serviços?',
      answer: 'Após 7 dias da aplicação, pode lavar normalmente. Recomendamos lavagem sem escovas e produtos neutros para maior durabilidade.',
      category: 'Cuidados'
    },
    {
      question: 'Os serviços afetam a garantia do veículo?',
      answer: 'Não! Nossos produtos são certificados e não afetam a garantia. Pelo contrário, ajudam a preservar o valor do seu investimento.',
      category: 'Garantia'
    },
    {
      question: 'Fazem orçamento sem compromisso?',
      answer: 'Sim! Fazemos avaliação gratuita e orçamento personalizado. Entre em contato via WhatsApp para agendar.',
      category: 'Atendimento'
    },
    {
      question: 'Qual o melhor período para aplicar PPF?',
      answer: 'Idealmente em carros novos (0km a 6 meses), mas também aplicamos em veículos usados após polimento técnico quando necessário.',
      category: 'Aplicação'
    },
    {
      question: 'Martelinho de ouro remove qualquer amassado?',
      answer: 'Remove amassados pequenos e médios sem danificar a pintura original. Avaliamos cada caso para garantir o melhor resultado.',
      category: 'Reparos'
    }
  ];

  const categories = ['Todos', 'Proteção', 'Conforto', 'Durabilidade', 'Cuidados', 'Garantia', 'Atendimento', 'Aplicação', 'Reparos'];
  const [activeCategory, setActiveCategory] = useState('Todos');

  const filteredFaqs = activeCategory === 'Todos' 
    ? faqs 
    : faqs.filter(faq => faq.category === activeCategory);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="py-12 bg-[#1C1C1C]" id="faq">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-montserrat font-bold text-white mb-3">
            <span className="text-[#C8A45D]">DÚVIDAS</span> FREQUENTES
          </h2>
          <p className="text-gray-300 font-open-sans">
            Respostas rápidas para suas principais questões
          </p>
        </div>

        {/* Filtros de Categoria */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                activeCategory === category
                  ? 'bg-[#C8A45D] text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* FAQs em formato accordion compacto */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-3">
            {filteredFaqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-[#0D0D0D] rounded-lg border border-gray-800 overflow-hidden hover:border-[#C8A45D]/50 transition-all duration-300"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full p-4 text-left flex items-center justify-between hover:bg-gray-900/50 transition-colors duration-300"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-xs font-bold text-black">{index + 1}</span>
                    </div>
                    <h3 className="text-sm font-montserrat font-semibold text-white">
                      {faq.question}
                    </h3>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-xs bg-[#C8A45D]/20 text-[#C8A45D] px-2 py-1 rounded-full">
                      {faq.category}
                    </span>
                    <i className={`ri-arrow-down-s-line text-[#C8A45D] transform transition-transform duration-300 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}></i>
                  </div>
                </button>
                
                <div className={`transition-all duration-300 ease-in-out ${
                  openFaq === index ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-gray-300 font-open-sans leading-relaxed pl-9">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-8">
          <p className="text-gray-400 text-sm mb-4">
            Não encontrou sua dúvida?
          </p>
          <a
            href="https://wa.me/554888397243?text=Olá! Tenho algumas dúvidas sobre os serviços."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-2.5 rounded-full font-medium transition-all duration-300 hover:shadow-lg hover:shadow-[#25D366]/20"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            <span>Fale Conosco</span>
          </a>
        </div>
      </div>
    </section>
  );
};
